<template>
  <div>
    <div
      :class="[
        'bg-white flex items-center w-full',
        { 'bg-gray-100': !isShow }
      ]"
    >
      <div class="text-xs text-gray-400 uppercase font-bold">
        <slot name="head" />
      </div>
    </div>
    <div v-if="isShow">
      <slot />
    </div>
    <hr
      class="my-6 border-0"
      style="height: 1px !important; background-color: #E2E2EA;"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
})
const isShow = computed(() => props.show)
</script>
